import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  // NOTE: regexValue must be a developer-controlled literal, never direct user input.
  // The try/catch below guards against malformed patterns causing a runtime error. (R2-10)
  transform(value: string, regexValue: string, replaceValue: string): any {
    try {
      const regex = new RegExp(regexValue, 'g');
      return value.replace(regex, replaceValue);
    } catch {
      // Invalid regex — return original value unchanged rather than throwing.
      return value;
    }
  }

}